module.exports = __webpack_public_path__ + "45380ccc95d2bd1b67ab28ce315bdf52.svg";